import Vue from 'vue'
import VueResource from 'vue-resource'
import { API_ROOT } from '../config'
import { getCookie, signOut } from '../utils/cookies'

Vue.use(VueResource)

Vue.http.options.crossOrigin = true
// Vue.http.options.credentials = true

Vue.http.interceptors.push((request, next) => {
  request.headers = request.headers || {}
  if (getCookie('token')) {
    // request.headers.Authorization = 'Bearer ' + getCookie('token')
    request.url = request.url + '?token=' + getCookie('token')
  }
  next((response) => {
    if ((response.status === 401 || response.status === 400) && response.data.error !== 'invalid_credentials') {
      signOut()

      let redirect = window.store.state.route.fullPath
      if (redirect.includes('redirect=')) {
        redirect = window.store.state.route.query.redirect
      }
      window.router.push({
        path: '/login',
        query: { redirect: redirect }
      })
    }
  })
})

// user authentication
export const Authenticate = function (user) {
  return Vue.http.post(API_ROOT + 'authenticate', user)
}

// REST resources
export const AuthResource = Vue.resource(API_ROOT + 'resource/authenticate')
export const CoachResource = Vue.resource(API_ROOT + 'resource/coach{/id}')
export const UserResource = Vue.resource(API_ROOT + 'resource/users{/id}')
export const SlideResource = Vue.resource(API_ROOT + 'resource/slide{/id}')
export const PanoramaPointResource = Vue.resource(API_ROOT + 'resource/point{/id}')
export const PanoramaCubeResource = Vue.resource(API_ROOT + 'resource/panorama/cube{/id}')
export const PanoramaResource = Vue.resource(API_ROOT + 'resource/panorama{/id}')
export const ExteriorResource = Vue.resource(API_ROOT + 'resource/exterior{/id}')

// Extras
// Coach
export const CoachScreensaver = function (data) {
  return Vue.http.post(API_ROOT + 'resource/coach/' + data.id + '/screensaver', data.data)
}
export const CoachState = function (data) {
  return Vue.http.post(API_ROOT + 'resource/coach/' + data.id + '/state', data.data)
}
export const ListCoachCategory = function (id) {
  return Vue.http.get(API_ROOT + 'resource/coach/' + id + '/category')
}
export const CoachCategory = function (data) {
  return Vue.http.post(API_ROOT + 'resource/coach/' + data.coach_id + '/category', data)
}
export const updateCategoryCoachState = function (data) {
  return Vue.http.post(API_ROOT + 'resource/coach/' + data.data.coach + '/category/state', data.data)
}
export const CoachCategoryRemove = function (data) {
  return Vue.http.post(API_ROOT + 'resource/coach/' + data.coach_id + '/category/remove', data)
}

// Slide
export const reorderSlides = function (data) {
  return Vue.http.post(API_ROOT + 'resource/slide/reorder', data)
}
export const SlideState = function (data) {
  return Vue.http.post(API_ROOT + 'resource/slide/' + data.id + '/state', data.data)
}

// Sub Slide
export const setSubSlideCategory = function (data) {
  return Vue.http.post(API_ROOT + 'resource/subslide/category', data)
}
export const deleteSubSlideCategory = function (data) {
  return Vue.http.delete(API_ROOT + 'resource/subslide/category/' + data)
}
export const updateSubSlideCategory = function (data) {
  return Vue.http.post(API_ROOT + 'resource/subslide/category/' + data.menu, data)
}

// Exteriors
export const reorderExteriors = function (data) {
  return Vue.http.post(API_ROOT + 'resource/exterior/reorder', data)
}
export const ExteriorState = function (data) {
  return Vue.http.post(API_ROOT + 'resource/exterior/' + data.id + '/state', data.data)
}



// WEBPACK FOOTER //
// ./src/api/resources.js